/**
 * 路線図で探すのスライダー
 */

import { showSlide } from '../function/showSlide';
import { updateActiveListItem } from '../function/updateActiveListItems';

export default class RestaurantRouteMap {
  constructor() {
    // ブランドリストを取得
    this.listItems = document.querySelectorAll('[data-restaurant]');
    this.splide = new Splide('#map-splide', {
      arrows: false,
      pagination: false,
    }).mount();
    // スライダーの移動イベントにリスナーを追加
    this.splide.on('move', (newIndex) => {
      updateActiveListItem(newIndex, this.listItems);
    });
  }

  /**
   * イベントを追加
   */
  addEvent() {
    this.listItems.forEach((item, index) => {
      item.addEventListener('click', (ev) => {
        ev.preventDefault();
        showSlide(index, this.listItems, this.splide);
      });
    });
  }

  init() {
    if (this.listItems.length === 0) return;
    this.addEvent();
  }
}
